module.exports = __webpack_public_path__ + "static/media/black-box-diaries.8f90071a.webp";